<template>
  <div class="modal-body text-break">
    <p class="text-end">{{ $moment(row.mailed_at).locale('ja').format('l(ddd)HH:mm') }}</p>
    <p v-html="addLinkTagsToBody" />
  </div>
</template>

<script>
export default {
  name: "MailModalBody",
  inject: [
    '$moment',
  ],
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    addLinkTagsToBody() {
      return this.row.body ? this.row.body.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1' target='_blank'>$1</a>") : '';
    }
  },
}
</script>

<style scoped>
.modal-body {
  min-height: 100px;
  margin-top: 10px;
}
</style>
